let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("88bR1")).then(() => parcelRequire('UHBCO'));